import React, { useContext } from 'react';
import { Banner, Button } from '@superops/ui-design-system';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import { FormattedMessage } from 'react-intl';

const NylasBanner = () => {
  const tabContext = useContext(TabContext);

  const handleNavigate = () => {
    tabContext.openTab({
      id: 'onboard-tab',
      module: 'ONBOARD',
      tabId: 'onboard-tab',
      url: '/onboard/mailserver'
    });
  };
  return (
    <Banner status="warning">
      <div className="flex g5 actr">
        <div>
          <FormattedMessage id="app.mail.connector.improve.banner.message" />
        </div>
        <div>
          <Button plain onClick={handleNavigate}>
            <FormattedMessage id="app.navigate.to.domain.and.email" />
          </Button>
        </div>
      </div>
    </Banner>
  );
};

export default NylasBanner;
